import React, { Component } from 'react'
import reactCSS from 'reactcss'
import Rotate90DegreesCcwIcon from '@material-ui/icons/Rotate90DegreesCcw';
import Slider from '@material-ui/core/Slider';
export default class RotatePicker extends Component {
    constructor(props){
        super(props);
        this.state ={
            displayPicker: false,
            align:'left',
            value:props.fBoxRotate.slice(0, -3)
        }
    }
    handleClick = () => {
        this.setState({ displayPicker: !this.state.displayPicker })
      };
    
      handleClose = () => {
        this.setState({ displayPicker: false })
      };
    
    
     handleChange =(event, newValue) =>{
       this.setState({value:newValue}, function() {
        this.props.handleBoxRotate(this.state.value);
      });
      }
      resetClick = () =>{
        this.setState({ value:0 },()=>{
          this.props.handleBoxRotate(this.state.value);
        })
      }
  render() {
    const styles = reactCSS({
        'default': {
          color: {
            width: '30px',
            height: '5px',
            borderRadius: '2px',
          },
          swatch: {
            background: '#fff',
            borderRadius: '1px',
            display: 'inline-block',
            cursor: 'pointer',
            textAlign:'center',
            border:'none',
            position:'relative'
          },
          popover: {
            marginTop:'10px',
            position: 'absolute',
            zIndex: '2',
            backgroundColor:'whitesmoke',
            minWidth:'120px',
            padding:'5px 5px 3px 5px',
            boxShadow:'2px 2px 15px rgb(0 0 0 / 10%)'
          },

          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            zIndex:-1
          },
        },
      });

      return (
        <div>
          <div style={ styles.swatch } onClick={ this.handleClick }>
                <Rotate90DegreesCcwIcon style={{fontSize:'20px'}}/> <span className='lhValue'>{this.state.value}deg</span>
          </div>
          { this.state.displayPicker ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
            <div className='popBox'>
            <Slider 
            step={1} 
            min={-90} 
            max={90} 
            value={this.state.value} 
            onChange={this.handleChange} 
            aria-labelledby="continuous-slider" 
            />
              <button onClick={this.resetClick} className="resetBtn">Reset</button>
            </div>
          
          </div> : null }
  
        </div>
      )
    }
  
}
